export enum ECOM_ERROR_CODE {
  DEFAULT_REFUND = 'DEFAULT_REFUND',
  // Requested refund amount exceeds the available refund amount for this order
  TYPE_CLIENT_ERROR_AMOUNT_EXCEEDED = 'TYPE_CLIENT_ERROR_AMOUNT_EXCEEDED',
  // Order already fully refunded
  TYPE_CLIENT_ERROR_ALREADY_REFUNDED = 'TYPE_CLIENT_ERROR_ALREADY_REFUNDED',
  // Trying refund with a poistive value
  TYPE_CLIENT_ERROR_AMOUNT_INVALID = 'TYPE_CLIENT_ERROR_AMOUNT_INVALID',
}

export const ECOM_ERRORS = [
  ECOM_ERROR_CODE.TYPE_CLIENT_ERROR_AMOUNT_EXCEEDED,
  ECOM_ERROR_CODE.TYPE_CLIENT_ERROR_ALREADY_REFUNDED,
  ECOM_ERROR_CODE.TYPE_CLIENT_ERROR_AMOUNT_INVALID,
]
